import { styled } from '@linaria/react'
import {
  BANNER_ASPECT_RATIO,
  COLOR,
  CORNERS,
  FIXED_INDENTS,
  MEDIA,
} from 'vars/index'

export const BannerPaginationWrapperSC = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(${FIXED_INDENTS.INDENT_40}) 0;

  ${MEDIA.MAX_599} {
    padding: var(${FIXED_INDENTS.INDENT_30}) 0;
  }

  /*
   * Compact home banners (600–1023) keep a dark description band under the
   * pinned 16:9 artwork. Pin dots to the artwork bottom, not the shell.
   */
  ${MEDIA.MIN_600} {
    ${MEDIA.MAX_1239} {
      bottom: max(
        0px,
        calc(100% - 100vw / var(${BANNER_ASPECT_RATIO.SIZE_50}))
      );
    }
  }

  ${MEDIA.MIN_1024} {
    bottom: 0;
  }
`

export const BannerPaginationSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: var(${FIXED_INDENTS.INDENT_10}) var(${FIXED_INDENTS.INDENT_20});
  border-radius: var(${CORNERS.CORNERS_PILL});
  background: var(${COLOR.SURFACE_OPACITY_DARK_60});
  backdrop-filter: blur(17.5px);
`

export const BannerPaginationDotSC = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    border-radius: var(${CORNERS.CORNERS_PILL});
    background: ${({ active }) =>
      active
        ? `var(${COLOR.SURFACE_CONSTANT_LIGHT})`
        : `var(${COLOR.SURFACE_OPACITY_LIGHT_10})`};
    width: ${({ active }) => (active ? '16px' : '8px')};
    height: 8px;
    transition:
      width 0.2s ease,
      background 0.2s ease;
  }
`
